/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var SIZE = {
  default: 'default',
  full: 'full',
  auto: 'auto'
};
export var SIZE_DIMENSION = {
  default: '500px',
  full: '100%',
  auto: 'auto'
};
export var CLOSE_SOURCE = {
  closeButton: 'closeButton',
  backdrop: 'backdrop',
  escape: 'escape'
};
export var ANCHOR = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom'
};